import { useContext } from 'react';

import { SliderStateContext } from 'react-aria-components/Slider';

import styles from './slider.module.css';

export function SliderTrackFill({ index = 0 }: { index?: number }) {
  const state = useContext(SliderStateContext);
  if (!state) {
    return null;
  }

  let start = 0;
  if (index > 0) {
    start = state.getThumbPercent(index - 1) * 100;
  }

  const size = state.getThumbPercent(index) * 100 - start;

  const stylesResult = {
    '--track-fill-start': `${start}%`,
    '--track-fill-size': `${size}%`,
  };

  return <div style={stylesResult} className={styles.slider_track_fill} />;
}
